import { AxiosResponse } from 'axios';
import { CustomJsonDraft, CustomJsonDraftIdentity } from '@/shared/interfaces/CustomJsonInterfaces';
import {
    DELIVERY_DRAFT_RESOURCE_TYPE,
    DELIVERY_DRAFT_TYPE,
    DeliveryDraftPayload,
} from '@/shared/interfaces/DeliveryDraftInterfaces';
import {
    deleteDraftByID,
    getAllDrafts,
    updateDraftByFullResource,
    createDraftByFullResource,
} from '@/shared/services/custom-json';

export async function getAllDeliveryDrafts(
    pageNumber = 1,
    pageSize = 10,
): Promise<AxiosResponse<Array<CustomJsonDraft<DeliveryDraftPayload>>>> {
    return getAllDrafts<DeliveryDraftPayload>({
        filters: {
            draftType: DELIVERY_DRAFT_TYPE,
            resourceType: DELIVERY_DRAFT_RESOURCE_TYPE,
        },
        sort: '-updatedAt',
        page: {
            number: pageNumber,
            size: pageSize,
        },
    });
}

export async function createDeliveryDraft(
    identity: CustomJsonDraftIdentity,
    payload: DeliveryDraftPayload,
): Promise<AxiosResponse<CustomJsonDraft<DeliveryDraftPayload>>> {
    return createDraftByFullResource(identity, payload);
}

export async function updateDeliveryDraft(
    identity: CustomJsonDraftIdentity,
    payload: DeliveryDraftPayload,
): Promise<AxiosResponse<CustomJsonDraft<DeliveryDraftPayload>>> {
    return updateDraftByFullResource(identity, payload);
}

export async function deleteDeliveryDraft(id: string): Promise<AxiosResponse<void>> {
    return deleteDraftByID(id);
}
